"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationAction = PaginationAction;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactVirtualized = require("react-virtualized");
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _excluded = ["cellRenderer", "count", "invert", "className", "onPrevious", "onNext", "enablePagination"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HorizontalList = function HorizontalList(_ref, ref) {
  var cellRenderer = _ref.cellRenderer,
    count = _ref.count,
    invert = _ref.invert,
    className = _ref.className,
    onPrevious = _ref.onPrevious,
    onNext = _ref.onNext,
    _ref$enablePagination = _ref.enablePagination,
    enablePagination = _ref$enablePagination === void 0 ? true : _ref$enablePagination,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var gridRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    update = _useState2[0],
    forceUpdate = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    scrollLeft = _useState4[0],
    setScrollLeft = _useState4[1];
  var isEnablePrevious = (0, _react.useMemo)(function () {
    if (gridRef.current) {
      var leftOffset = (0, _isNil["default"])(scrollLeft) ? gridRef.current.state.scrollLeft : scrollLeft;
      var width = gridRef.current.props.width;
      var totalColumnsWidth = gridRef.current.getTotalColumnsWidth();
      if (width < totalColumnsWidth) {
        return leftOffset !== 0;
      }
    }
    return false;
  }, [scrollLeft, update]);
  var isEnableNext = (0, _react.useMemo)(function () {
    if (gridRef.current) {
      var leftOffset = (0, _isNil["default"])(scrollLeft) ? gridRef.current.state.scrollLeft : scrollLeft;
      var width = gridRef.current.props.width;
      var totalColumnsWidth = gridRef.current.getTotalColumnsWidth();
      if (width < totalColumnsWidth) {
        return leftOffset + width < totalColumnsWidth;
      }
    }
    return false;
  }, [scrollLeft, update]);
  var handleScrollNext = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    var getNextScrollLeft = function getNextScrollLeft() {
      if (gridRef.current) {
        var _scrollLeft = gridRef.current.state.scrollLeft;
        var _gridRef$current$prop = gridRef.current.props,
          columnWidth = _gridRef$current$prop.columnWidth,
          width = _gridRef$current$prop.width;
        if ((0, _isFunction["default"])(columnWidth)) {
          var left = 0;
          for (var i = 0; i < count; i++) {
            var currWidth = columnWidth({
              index: i
            });
            if (left + currWidth > _scrollLeft + width) {
              return left;
            }
            left += currWidth;
          }
        } else {
          return Math.floor((_scrollLeft + width) / columnWidth) * columnWidth;
        }
      }
      return 0;
    };
    var node = gridRef.current && gridRef.current._scrollingContainer;
    if (node) {
      var left = getNextScrollLeft();
      node.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }
    if (!(0, _isNil["default"])(onNext)) {
      onNext();
    }
  }, [count, onNext]);
  var handleScrollPrevious = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    var getPreviousScrollLeft = function getPreviousScrollLeft() {
      if (gridRef.current) {
        var _scrollLeft2 = gridRef.current.state.scrollLeft;
        var _gridRef$current$prop2 = gridRef.current.props,
          columnWidth = _gridRef$current$prop2.columnWidth,
          width = _gridRef$current$prop2.width;
        if (_scrollLeft2 - width < 0) return 0;
        if ((0, _isFunction["default"])(columnWidth)) {
          var left = 0;
          for (var i = 0; i < count; i++) {
            var currWidth = columnWidth({
              index: i
            });
            if (left + currWidth > _scrollLeft2 - width) {
              return left + currWidth;
            }
            left += currWidth;
          }
        } else {
          return Math.ceil((_scrollLeft2 - width) / columnWidth) * columnWidth;
        }
      }
      return -1;
    };
    var node = gridRef.current && gridRef.current._scrollingContainer;
    if (node) {
      var left = getPreviousScrollLeft();
      node.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }
    if (!(0, _isNil["default"])(onPrevious)) {
      onPrevious();
    }
  }, [count, onPrevious]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      recompute: function recompute() {
        if (gridRef.current) {
          gridRef.current.recomputeGridSize();
        }
      },
      container: gridRef.current && gridRef.current._scrollingContainer
    };
  }, [!!gridRef.current]);

  //trigger grid rendered
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      return forceUpdate(function (data) {
        return !data;
      });
    });
  }, [count]);
  var handleOnScroll = (0, _react.useCallback)(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      scrollLeft = _ref2.scrollLeft;
    setScrollLeft(scrollLeft);
  }, []);
  var overscanIndicesGetter = (0, _react.useCallback)(function (_ref3) {
    var direction = _ref3.direction,
      cellCount = _ref3.cellCount,
      scrollDirection = _ref3.scrollDirection,
      overscanCellsCount = _ref3.overscanCellsCount,
      startIndex = _ref3.startIndex,
      stopIndex = _ref3.stopIndex;
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  }, []);
  var list = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
      disableHeight: true
    }, function (_ref4) {
      var width = _ref4.width;
      return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Grid, (0, _extends2["default"])({}, rest, {
        ref: gridRef,
        width: width,
        rowCount: 1,
        columnCount: count,
        className: (0, _classnames["default"])('outline-none !overflow-y-hidden scrollbar-hidden', className),
        onScroll: handleOnScroll,
        overscanColumnCount: 5,
        overscanIndicesGetter: overscanIndicesGetter,
        cellRenderer: cellRenderer
      }));
    });
  }, [count, handleOnScroll, cellRenderer, rest]);
  var previousButton = (0, _react.useMemo)(function () {
    return isEnablePrevious && /*#__PURE__*/_react["default"].createElement("div", {
      className: "absolute top-0 left-0 h-full"
    }, /*#__PURE__*/_react["default"].createElement(PaginationAction, {
      className: (0, _classnames["default"])({
        'gradient bg-gradient-l': !invert
      }),
      onClick: handleScrollPrevious
    }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null)));
  }, [isEnablePrevious, handleScrollPrevious]);
  var nextButton = (0, _react.useMemo)(function () {
    return isEnableNext && /*#__PURE__*/_react["default"].createElement("div", {
      className: "absolute top-0 right-0 h-full"
    }, /*#__PURE__*/_react["default"].createElement(PaginationAction, {
      className: (0, _classnames["default"])({
        'gradient bg-gradient-r': !invert
      }),
      onClick: handleScrollNext
    }, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], null)));
  }, [isEnableNext, handleScrollNext]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, list, enablePagination && previousButton, enablePagination && nextButton);
};
function PaginationAction(_ref5) {
  var _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
    children = _ref5.children,
    onClick = _ref5.onClick,
    _ref5$className = _ref5.className,
    className = _ref5$className === void 0 ? '' : _ref5$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('h-full flex items-center', className)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "rounded-full shadow-lg p-2 bg-app text-gray-medium hover:text-primary hover:bg-secondary dark:bg-secondary dark:shadow-shallow",
    onClick: onClick
  }, children));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(HorizontalList);
//# sourceMappingURL=index.js.map